module.exports = __webpack_public_path__ + "static/media/5.24c76bbf.mp3";